module.exports = __webpack_public_path__ + "static/media/oatmeal-chocolate-walnut-deluxe.a89a3306.png";